namespace nscs.input {
    export class InputController {

        cursorKeys:Phaser.Types.Input.Keyboard.CursorKeys;
        spaceObj: Phaser.Input.Keyboard.Key;
        escObj: Phaser.Input.Keyboard.Key;
        enterObj: Phaser.Input.Keyboard.Key;

        scene:Phaser.Scene;
        constructor(scene:Phaser.Scene) {
            this.scene = scene;

            this.cursorKeys = this.scene.input.keyboard.createCursorKeys();
            this.cursorKeys.down.on('up', () => {this.cursorKeys.down['-used-'] = false;});
            this.cursorKeys.down['-used-'] = false;
            this.scene.input.keyboard.addCapture([Phaser.Input.Keyboard.KeyCodes.LEFT, Phaser.Input.Keyboard.KeyCodes.RIGHT]);

            this.spaceObj = scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE);  // Get key object
            this.spaceObj.on('up', () => {this.spaceObj['-used-'] = false;});
            this.spaceObj['-used-'] = false;

            this.escObj = scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.ESC);  // Get key object
            this.escObj.on('up', () => {this.escObj['-used-'] = false;});
            this.escObj['-used-'] = false;

            this.enterObj = scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.ENTER);  // Get key object
            this.enterObj.on('up', () => {this.enterObj['-used-'] = false;});
            this.enterObj['-used-'] = false;
        }

        public spacePressedDownAndReleased():boolean {
            return this.spaceObj.isDown && !this.spaceObj['-used-'];
        }
        public spacePressUsed():void {
            this.spaceObj['-used-'] = true;
        }

        public keyDownPressedDownAndReleased():boolean {
            return this.cursorKeys.down.isDown && !this.cursorKeys.down['-used-'];
        }
        public keyDownPressUsed():void {
            this.cursorKeys.down['-used-'] = true;
        }

        public escPressedDownAndReleased():boolean {
            return this.escObj.isDown && !this.escObj['-used-'];
        }
        public escPressUsed():void {
            this.escObj['-used-'] = true;
        }

        public enterPressedDownAndReleased():boolean {
            return this.enterObj.isDown && !this.enterObj['-used-'];
        }
        public enterPressUsed():void {
            this.enterObj['-used-'] = true;
        }
    }
}